import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71861f48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tool_tip_wrap" }
const _hoisted_2 = { class: "tool_tip" }
const _hoisted_3 = { class: "title" }

import SimpleRadioButton from '@/components/atoms/SimpleRadioButton.vue'
import { computed } from 'vue'

type PropsType = {
  modelValue: number
  options?: { [key: string]: string | number }[]
  title?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioButtonToolTip',
  props: {
    modelValue: null,
    options: null,
    title: null
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: number): void
  (e: 'change', value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: number
  options?: { [key: string]: string | number }[]
  title?: string
};




const selectedValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
    // TODO 親コンポーネントで'update:modelValue'を利用すればchangeは不要だが、利用しているコンポーネントの修正がなるべく発生しないように2重でchangeイベントを追加している。
    emit('change', value)
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
          return (_openBlock(), _createElementBlock("li", {
            key: option.label
          }, [
            _createVNode(SimpleRadioButton, {
              modelValue: _unref(selectedValue),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedValue) ? (selectedValue).value = $event : null)),
              label: option.label,
              text: option.text
            }, null, 8, ["modelValue", "label", "text"])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})